import { ActionBrick, registerBrick, BrickContext, User, ErrorFlow, Transaction } from 'olympe';
import { getLogger } from '@olympeio/core';

export default class SetUserPassword extends ActionBrick {

    /**
     * @protected
     * @param {!BrickContext} $
     * @param {*} user
     * @param {string} password
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     * @param {function(*)} setUser
     */
    update($, [user, password], [forwardEvent, setUser, setErrorFlow]) {
        const transaction = Transaction.from($);

        const login = /** @type {string} */ (this.db.getProperty(user, User.loginProp));
        // Generate SRP authentication data from the password
        const srpClient = new SRPClient();
        const salt = srpClient['generateRandomSalt']();
        const verifier = srpClient['generateVerifier'](salt, login, password)

        // Update user
        transaction.update(user, User.saltProp, salt);
        transaction.update(user, User.verifierProp, verifier);

        Transaction.process($, transaction).then(() => {
            setUser(user);
            forwardEvent();
        }).catch((message) => {
            // In case of error, dispatch the error flow
            getLogger('SetUserPassword').error(message);
            setErrorFlow(ErrorFlow.create(
                'Connected user is not allowed to change password',
                401
            ));
        });
    }
}

registerBrick('018ef6127788272246e5', SetUserPassword);
